import React from 'react'
import { useNavigate } from 'react-router-dom'

const VerticalTabs = () => {
  const Navigate = useNavigate();
  const page = window.location.pathname;

  return (
    <div className={`vertical-tabs ${page.includes('/page1') ? 'touchTop' : 'orders-page'}`}>
      <div
        onClick={() => Navigate('/page1')}
        className={`tabs ${page.includes('/page1') ? 'active' : ''}`}
      >{'SEATS'.split('').map((character => <h2 key={Math.random()}>{character}</h2>))}
      </div>
      <div
        onClick={() => Navigate('/orders')}
        className={`tabs ${page.includes('/orders') ? 'active' : ''}`}
      >{'ORDERS'.split('').map((character => <h2 key={Math.random()}>{character}</h2>))}
      </div>
    </div>
  )
}

export default VerticalTabs
